import React, { useState, useEffect } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { useParams } from "react-router-dom";
import {
  getLegislatorUsingEmail,
  getLegislatorUsingId,
} from "../../utils/legislatorsOperations";
import LegislatorHeader from "./LegislatorHeader/LegislatorHeader";
import Stats from "./Stats/Stats";
import HeroSection from "./HeroSection/HeroSection";
import LegislatorTabs from "./Tabs/Tabs";

const LegislatorDetails = () => {
  const [legislator, setLegislator] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchLegislatorDetails = async () => {
      try {
        const legislatorDetails = await getLegislatorUsingId(id);
        const legislatorProfile = await getLegislatorUsingEmail(
          legislatorDetails.emailAddress
        );
        setLegislator({ legislatorDetails, ...{ legislatorProfile } });
      } catch (err) {
        console.error("Error fetching legislator:", err);
      }
    };
    fetchLegislatorDetails();
  }, [id]);

  if (!legislator) return <div>Loading...</div>;

  return (
    <>
      <HeroSection legislator={legislator} />
      <div className="py-4 divider">
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol xl="3" lg="4" className="mb-3 mb-lg-0">
              <LegislatorHeader legislator={legislator} />
            </MDBCol>
            <MDBCol xl="9" lg="8">
              <LegislatorTabs legislator={legislator} />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      {/* <div className="py-4 bg-white">
        <MDBContainer fluid>
          <Stats legislator={legislator} />
        </MDBContainer>
      </div> */}
    </>
  );
};

export default LegislatorDetails;
